<app-design-colors-inserter [design]="bucket.designs.brand">
  <div class="toolbar" *transloco="let t; read: 'rich_text'">

    @if (bucket.localized) {
      <a [routerLink]="['', {outlets: {modal: ['m', bucketTypeNamespace, bucket.id, 'blocks', richTextBlockIds?.[0], 'localization']}}]"
         (click)="close.emit(true)"
         class="btn px-2"
         data-tooltip-position="top" [attr.data-tooltip-text]="t('localize')">
        <fa-icon [icon]="['far', 'globe']"></fa-icon>
      </a>
      <div class="separator"></div>
    }

    <app-dropdown [nestedDropdown]="true" elevation="3" placement="bottom-start">
      <div *dropdownTrigger data-tooltip-position="top" [attr.data-tooltip-text]="t('styles')">
        <button type="button" class="btn px-2 dropdown-toggle">
          {{ t(state?.header?.label || 'text') }}
        </button>
      </div>

      <div *dropdownPanel>
        <ul class="dropdown-menu d-block position-relative" style="min-width: auto">
          @for (header of headers; track header.value) {
            <li role="menuitem">
              <button class="dropdown-item" (click)=" richTextService.setHeader(richTextBlockIds, header) ">
                {{ t(header.label) }}
              </button>
            </li>
          }
        </ul>
      </div>
    </app-dropdown>

    <div class="separator"></div>

    @if (!state?.header) {
      <app-dropdown [nestedDropdown]="true" elevation="3" placement="bottom-start">
        <div *dropdownTrigger data-tooltip-position="top" [attr.data-tooltip-text]="t('font_size')">
          <button type="button" class="btn px-2 dropdown-toggle">
            {{ state?.size || '16' }}
          </button>
        </div>

        <ul *dropdownPanel class="dropdown-menu d-block position-relative" style="min-width: auto">
          <li *ngFor=" let size of sizes " role="menuitem">
            <button class="dropdown-item" (click)=" format('size', size.value) ">
              {{ size.label || size.value }}
            </button>
          </li>
        </ul>
      </app-dropdown>

      <div class="separator"></div>
    }

    <app-dropdown [nestedDropdown]="true" elevation="3" placement="bottom-start">
      <div *dropdownTrigger data-tooltip-position="top" [attr.data-tooltip-text]="t('font')">
        <button type="button" class="btn px-2 dropdown-toggle">
          <pl-icon icon="richTextFont"></pl-icon>
        </button>
      </div>

      <ul *dropdownPanel class="dropdown-menu d-block position-relative">
        <li role="menuitem">
          <button class="dropdown-item" (click)=" format('font') ">
            {{ t('sans_serif') }}
          </button>
        </li>

        <li role="menuitem">
          <button class="dropdown-item" (click)=" format('font', 'serif') ">
            {{ t('serif') }}
          </button>
        </li>
      </ul>
    </app-dropdown>

    <div class="separator"></div>

    <button type="button" class="btn px-2" [class.active]=" state?.bold " (click)=" format('bold', !state?.bold) "
            data-tooltip-position="top" [attr.data-tooltip-text]="t('bold') + ' (' + t(shortcutKey) + '+B)'">
      <pl-icon icon="richTextBold"></pl-icon>
    </button>

    <button type="button" class="btn px-2" [class.active]=" state?.italic " (click)=" format('italic', !state?.italic) "
            data-tooltip-position="top" [attr.data-tooltip-text]="t('italic') + ' (' + t(shortcutKey) + '+I)'">
      <pl-icon icon="richTextItalic"></pl-icon>
    </button>

    <button type="button" class="btn px-2" [class.active]=" state?.underline "
            (click)=" format('underline', !state?.underline) "
            data-tooltip-position="top" [attr.data-tooltip-text]="t('underline') + ' (' + t(shortcutKey) + '+U)'">
      <pl-icon icon="richTextUnderline"></pl-icon>
    </button>

    <button type="button" class="btn px-2" [class.active]=" state?.strike " (click)=" format('strike', !state?.strike) "
            data-tooltip-position="top" [attr.data-tooltip-text]="t('strike')">
      <pl-icon icon="richTextStrike"></pl-icon>
    </button>

    <div class="separator"></div>

    <app-dropdown [nestedDropdown]="true" elevation="3" [hideOnInnerClick]=" false " #colorDropdown
                  placement="bottom-start">
      <div *dropdownTrigger data-tooltip-position="top" [attr.data-tooltip-text]="t('color')">
        <button type="button" class="btn px-2 dropdown-toggle">
          <pl-icon [style.color]="state?.color || '#000000'" icon="richTextColor"></pl-icon>
        </button>
      </div>

      <div *dropdownPanel class="m-2 dropdown-panel">
        <pl-color-panel
          [ngModel]="state?.color || '#000'"
          (ngModelChange)=" colorChange($event) "
          [showResetButton]="true"
          defaultValue="#000" />
      </div>
    </app-dropdown>

    <app-dropdown [nestedDropdown]="true" elevation="3" [hideOnInnerClick]=" false " #backgroundDropdown
                  placement="bottom-start">
      <div *dropdownTrigger data-tooltip-position="top" [attr.data-tooltip-text]="t('background')">
        <button type="button" class="btn px-2 dropdown-toggle">
          <pl-icon icon="richTextBackground" [style.color]="state?.background || '#000000'"></pl-icon>
        </button>
      </div>

      <div *dropdownPanel class="m-2 dropdown-panel">

        <pl-color-panel
          [ngModel]="state?.background || '#ffffff00'"
          (ngModelChange)=" backgroundChange($event) "
          [showResetButton]="true"
          defaultValue="#ffffff00" />

      </div>
    </app-dropdown>

    <div class="separator"></div>

    <app-dropdown [nestedDropdown]="true" elevation="3" placement="bottom-start">
      <div *dropdownTrigger data-tooltip-position="top" [attr.data-tooltip-text]="t('align')">
        <button type="button" class="btn px-2 dropdown-toggle">
          @switch (state?.align) {
            @case ('center') {
              <pl-icon icon="richTextCenter"></pl-icon>
            }
            @case ('right') {
              <pl-icon icon="richTextRight"></pl-icon>
            }
            @case ('justify') {
              <pl-icon icon="richTextJustify"></pl-icon>
            }
            @default {
              <pl-icon icon="richTextLeft"></pl-icon>
            }
          }
        </button>
      </div>

      <ul *dropdownPanel class="dropdown-menu d-block position-relative">
        <li role="menuitem">
          <button class="dropdown-item" (click)=" format('align') ">
            <pl-icon icon="richTextLeft"></pl-icon>
            {{ t('left') }}
          </button>
        </li>

        <li role="menuitem">
          <button class="dropdown-item" (click)=" format('align', 'center') ">
            <pl-icon icon="richTextCenter"></pl-icon>
            {{ t('center') }}
          </button>
        </li>

        <li role="menuitem">
          <button class="dropdown-item" (click)=" format('align', 'right') ">
            <pl-icon icon="richTextRight"></pl-icon>
            {{ t('right') }}
          </button>
        </li>

        <li role="menuitem">
          <button class="dropdown-item" (click)=" format('align', 'justify') ">
            <pl-icon icon="richTextJustify"></pl-icon>
            {{ t('justify') }}
          </button>
        </li>
      </ul>

    </app-dropdown>

    <div class="separator"></div>

    <button type="button" class="btn px-2" [class.active]=" state?.list === 'bullet' "
            (click)="format('list', state?.list === 'bullet' ? false : 'bullet')"
            data-tooltip-position="top"
            [attr.data-tooltip-text]="t('ul')">
      <pl-icon icon="richTextUl"></pl-icon>
    </button>

    <button type="button" class="btn px-2" [class.active]=" state?.list === 'ordered' "
            (click)=" format('list', state?.list === 'ordered' ? false : 'ordered' ) "
            data-tooltip-position="top"
            [attr.data-tooltip-text]="t('ol')">
      <pl-icon icon="richTextOl"></pl-icon>
    </button>

    <div class="separator"></div>

    <button type="button" class="btn px-2" (click)=" format('indent', state?.indent - 1) "
            data-tooltip-position="top" [attr.data-tooltip-text]="t('outdent') + ' (' + t('shift') + '+Tab)'">
      <pl-icon icon="richTextOutdent"></pl-icon>
    </button>

    <button type="button" class="btn px-2" (click)=" format('indent', state?.indent + 1) "
            data-tooltip-position="top" [attr.data-tooltip-text]="t('indent') + ' (Tab)'">
      <pl-icon icon="richTextIndent"></pl-icon>
    </button>

    <div class="separator"></div>

    <app-dropdown [nestedDropdown]="true" elevation="3" [hideOnInnerClick]=" false " #linkDropdown
                  placement="bottom-start">
      <div *dropdownTrigger data-tooltip-position="top" [attr.data-tooltip-text]="t('link')">
        <button type="button" class="btn px-2 dropdown-toggle" [class.active]=" state?.link ">
          <pl-icon icon="richTextLink"></pl-icon>
        </button>
      </div>

      <div *dropdownPanel class="dropdown-menu d-block position-relative px-3 pb-3">
        <div class="form-group">
          <label for="link-url">
            {{ t('address') }}
          </label>

          <div class="position-relative mb-3">
            <input type="text" class="form-control form-control-sm" required [ngModel]=" state?.link " name="linkUrl"
                   id="link-url" #linkControl="ngModel">
          </div>
        </div>

        <div>
          <button class="btn btn-link" (click)=" linkDropdown.toggle() ">
            {{ t('cancel') }}
          </button>

          @if (state?.link) {
            <button class="btn btn-light ml-2 btn-sm"
                    (click)=" linkDropdown.toggle(); format('link', false) ">
              {{ t('remove') }}
            </button>
          }

          <button class="btn btn-primary ml-2 btn-sm" [disabled]=" !state?.link && linkControl.invalid "
                  (click)=" linkDropdown.toggle(); format('link', linkControl.value) ">
            {{ t('save') }}
          </button>
        </div>
      </div>
    </app-dropdown>

    <div class="separator"></div>

    @if (showVariableButton) {
      <button #variableDropdownTrigger type="button" class="btn px-2 text-nowrap variable-trigger"
              (click)="variableDropdown.toggle(); mapVariables(); variableSearchQuery = ''">
        {{ t('variable') }} <b>+</b>
      </button>

      <app-dropdown [nestedDropdown]="true" elevation="3" [externalTarget]="variableDropdownTrigger"
                    [hideOnInnerClick]=" false " #variableDropdown>
        <div class="variable-dropdown-panel" *dropdownPanel>
          <div class="py-2" [class.border-bottom]="variablesMapped.length">
            @if (!selectedVariable && selectedText) {
              <button class="dropdown-item add-variable" [class.primary]="!selectedText"
                      (click)="addVariable(); variableDropdown.hide()">
                <b>+</b> <span [innerHTML]=" t('add_as_variable', {selectedText: selectedText}) "></span>
              </button>
            }

            @if (!selectedVariable && !selectedText) {
              <button class="dropdown-item primary" (click)="addVariable();">
                <b>+</b> {{ t('add_new_variable') }}
              </button>
            }

            @if (selectedVariable) {
              <button class="dropdown-item"
                      (click)="insertVariable(selectedVariable.variable.name); variableDropdown.hide()">
                <span [innerHTML]=" t('link_variable', {variable: selectedVariable.variable.name}) "></span>
              </button>
            }
          </div>

          @if (variablesMapped.length > 6) {
            <app-search
              [placeholder]="t('search_variable', {count: variablesMapped.length})"
              [routeChange]="false"
              (queryChange)="variableSearchQuery = $event"
              #searchVariable
              class="clean border-bottom d-block" />
          }

          <ul class="dropdown-menu d-block position-relative w-100 mt-0 py-1" *ngIf="variablesMapped?.length">
            @for (v of variablesMapped | stringFilter:[{property: 'name', value: variableSearchQuery.toLowerCase()}]; track v.name) {
              <li role="menuitem">
                <button class="dropdown-item" (click)=" insertVariable(v.variable.name); variableDropdown.hide()">
                  {{ v.variable.name }}
                </button>
              </li>
            }
          </ul>
        </div>
      </app-dropdown>

      <div class="separator"></div>

      <button type="button" class="btn px-2" (click)=" richTextService.undo(richTextBlockIds) "
              data-tooltip-position="top" [attr.data-tooltip-text]="t('undo') + ' (' + t(shortcutKey) + '+Z)'">
        <pl-icon icon="richTextUndo"></pl-icon>
      </button>

      <button type="button" class="btn px-2" (click)=" richTextService.redo(richTextBlockIds) "
              data-tooltip-position="top"
              [attr.data-tooltip-text]="t('redo') + ' (' + t(shortcutKey) + '+' + t('shift') + '+Z)'">
        <pl-icon icon="richTextRedo"></pl-icon>
      </button>

      <div class="separator"></div>

      <button type="button" class="btn px-2" (click)=" moreDropdown.toggle() " #moreTrigger>
        <fa-icon [fixedWidth]=" true " [icon]="['fas', 'ellipsis-h']"></fa-icon>
      </button>

      <app-dropdown [nestedDropdown]="true" elevation="3" [externalTarget]=" moreTrigger " #moreDropdown>
        <ul *dropdownPanel class="dropdown-menu d-block position-relative">
          <li role="menuitem">
            <button class="dropdown-item" (click)=" clean() ">
              <pl-icon icon="richTextClean"></pl-icon>
              {{ t('clean') }}
            </button>
          </li>

          <li role="menuitem">
            <button class="dropdown-item" (click)=" format('blockquote', !state?.blockquote) ">
              <pl-icon icon="richTextQuote"></pl-icon>
              {{ t('blockquote') }}
            </button>
          </li>

          <li role="menuitem">
            <button class="dropdown-item" [class.active]=" state?.script === 'super' "
                    (click)=" format('script', state?.script === 'super' ? undefined : 'super') ">
              <pl-icon icon="richTextSuperscript"></pl-icon>
              {{ t('superscript') }}
            </button>
          </li>

          <li role="menuitem">
            <button class="dropdown-item" [class.active]=" state?.script === 'sub' "
                    (click)=" format('script', state?.script === 'sub' ? undefined : 'sub') ">
              <pl-icon icon="richTextSubscript"></pl-icon>
              {{ t('subscript') }}
            </button>
          </li>
        </ul>
      </app-dropdown>
    }
  </div>
</app-design-colors-inserter>
